export const environment = {
    production: false,
    AUTH_ORIGIN: "https://maritime-stage.pragma-iot.com/api",
    API_ORIGIN: "https://maritime-stage.pragma-iot.com/api",
    API_ANALYTICS_ORIGIN: "https://maritime-stage.pragma-iot.com/api/analytics-new",
    API_MEASUREMENTS_ORIGIN: "https://maritime-stage.pragma-iot.com/data",
    googleMapsApiKey: "AIzaSyCx8_gLbIJ_hiV4ABrMlXSBZP4ciOptgig",
    mqttEnabled: true,
    mqttUrl: "wss://maritime-stage.pragma-iot.com/wss/",
    mqttUser: "user1",
    mqttPassword: "user1",
    sidebar: {
        defaultMode: "drawer", // "drawer" | "static"
        defaultAnchored: false,
    },
    pragmaAgentEnabled: false,
    pragmaAgentEmbedUrl:
        "https://pragma-agent.lmak.gr/embed/pragma-agent.iife.js",
    pragmaAgentApiUrl: "https://pragma-agent.lmak.gr",
    pragmaAgentToken: "pra_d6b34720e01f32834c4ce6c8a749605acb0d1de8",
    dynamicResolutionTargetPoints: 1000,
};
